import {
  AxiosHeaders,
  isAxiosError,
  type InternalAxiosRequestConfig,
} from 'axios';

// Late trusted response interceptors can retry without exposing credentials to
// callers that log the error. Entries disappear when their error is collected.
const requestConfigs = new WeakMap<
  object,
  InternalAxiosRequestConfig<unknown>
>();

/** Remove public request diagnostics while retaining the original error contract. */
export function redactAxiosRequestError<T>(error: T): T {
  if (!isAxiosError<unknown, unknown>(error)) return error;
  if (error.config && !requestConfigs.has(error)) {
    requestConfigs.set(error, error.config);
  }
  delete error.config;
  delete error.request;
  if (error.response) {
    const response = {
      ...error.response,
      config: { headers: new AxiosHeaders() },
    };
    delete response.request;
    error.response = response;
  }
  return error;
}

/** Original request configuration for trusted retry handlers, never for diagnostics. */
export function getOriginalAxiosRequestConfig(
  error: unknown
): InternalAxiosRequestConfig<unknown> | undefined {
  if (!isAxiosError<unknown, unknown>(error)) return undefined;
  return requestConfigs.get(error) ?? error.config;
}
